module.exports = __webpack_public_path__ + "images/application/flags-1f575b9f.png";